import { format } from 'date-fns-tz';

export const getPublishStepPayload = (publicationDate: Date): string => {
  return format(publicationDate, "yyyy-MM-dd'T'HH:mm:ssxxx", {
    timeZone: 'America/Sao_Paulo',
  });
};
